import BpkInfoBanner, {
  ALERT_TYPES,
} from '@skyscanner-internal/backpack-web/bpk-component-info-banner';

const createMarkup = (markup: string) => ({ __html: markup });

/* eslint-disable react/no-danger */
const FooterBlurb = ({ disclaimer }: { disclaimer: string }) => (
  <BpkInfoBanner
    message={<span dangerouslySetInnerHTML={createMarkup(disclaimer)} />}
    type={ALERT_TYPES.INFO}
  />
);
/* eslint-enable react/no-danger */

export default FooterBlurb;
